import { useEffect, MutableRefObject } from 'react'

export default function useProcessSpy(
  flagDomRef: MutableRefObject<HTMLElement | null>,
  processNow: MutableRefObject<number>,
  initialTop: MutableRefObject<number>,
  sendTea: Function
) {
  useEffect(() => {
    function handler() {
      const body = document.documentElement || document.body
      if (flagDomRef.current) {
        const windowHeight = body.clientHeight
        const topNow = flagDomRef.current.getBoundingClientRect().top

        let process
        if (initialTop.current - windowHeight <= 0) {
          process = 1
        } else {
          process =
            1 - (topNow - windowHeight) / (initialTop.current - windowHeight)
        }

        if (process > 1) {
          process = 1
        }

        if (processNow.current < 1 && process === 1) {
          sendTea()
        }
        processNow.current = process
      }
    }
    window.addEventListener('scroll', handler)

    return () => {
      window.removeEventListener('scroll', handler)
    }
  }, [])
}
